(function() {
    'use strict';

    angular
        .module('atheer.invitation', [

        ]);
})();
